/**
 * 枚举类型定义
 * 与后端保持一致
 */

/**
 * 用户角色
 */
export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MEMBER = 'member',
  DEVELOPER = 'developer',  // MemoryService 的角色
  USER = 'user',  // MemoryService 的角色
}

/**
 * 用户状态
 */
export enum UserStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  PENDING = 'pending',  // MemoryService 的状态
  REJECTED = 'rejected',  // MemoryService 的状态
}

/**
 * 项目状态
 */
export enum ProjectStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  MAINTENANCE = 'maintenance',
}

/**
 * 成员权限/角色
 * 与后端保持一致：owner | admin | member
 */
export type MemberPermission = 'owner' | 'admin' | 'member'

/**
 * 消息角色
 */
export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system',
}

/**
 * 节点类型
 */
export enum NodeType {
  ENTRY = 'entry',
  AGENT = 'agent',
  ROUTER = 'router',
  OUTPUT = 'output',
}

